module.exports = __webpack_public_path__ + "static/img/red-bg.cc368fe3.jpg";